// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__2c7Yl","control":"ProfileForm_control__VKQGW","action":"ProfileForm_action__-TjRV"};